import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import PaymentDisclaimer from '../paymentDisclaimer/PaymentDisclaimer';
import MergedPaymentPage from '../MergedPaymentPage';

export const MergedPayment: FunctionComponent = () => {
  return (
    <Box>
      <PaymentDisclaimer />
      <MergedPaymentPage showCheckoutButton />
    </Box>
  );
};
